import Link from "@mui/material/Link"
import { Link as RouterLink } from "react-router-dom"

export default function TextLink({ to, text, linkProps }) {
  return (
    <Link variant="body1" component={RouterLink} to={to} {...linkProps}>
      {text}
    </Link>
  )
}
